// src/actions/cartAction.js

import {
  ADD_TO_CART,
  CLEAR_CART,
  DOWNGRADE_CART_ITEM_QUANTITY,
  REMOVE_FROM_CART,
  UPDATE_CART_ITEM_QUANTITY,
  UPDATE_CART_DISCOUNT,
  UPDATE_CART_ITEM,
  SET_ORDER_TYPE,
  APPLY_GLOBAL_DISCOUNT,
  REMOVE_GLOBAL_DISCOUNT,
  APPLY_TAX,
  REMOVE_TAX,
  SET_CUSTOMER,
  CLEAR_CUSTOMER,
  SET_PAYMENT_METHOD,
  APPLY_PROMOTION,
  REMOVE_PROMOTION,
} from './types';

// Basic Cart Operations
export const AddToCart = (item) => ({
  type: ADD_TO_CART,
  payload: item,
});

export const RemoveFromCart = (itemId, index) => ({
  type: REMOVE_FROM_CART,
  payload: { itemId, index },
});

export const updateCartItemQuantity = (index, itemId, quantity = 1) => ({
  type: UPDATE_CART_ITEM_QUANTITY,
  payload: { index, itemId, quantity },
});

export const downgradeCartItemQuantity = (index, itemId, quantity = 1) => ({
  type: DOWNGRADE_CART_ITEM_QUANTITY,
  payload: { index, itemId, quantity },
});

export const updateCartItem = (updatedItem) => ({
  type: UPDATE_CART_ITEM,
  payload: updatedItem,
});

export const clearCart = () => ({
  type: CLEAR_CART,
});

// Discount Operations
// Discount Operations
export const updateDiscount = (
  index,
  itemId,
  discount,
  selectedPromotionDetails,
  discountType,
  discountId,
  promotionId,
  isOrderLevelDiscount = false // 👈 NEW
) => ({
  type: UPDATE_CART_DISCOUNT,
  payload: {
    index,
    itemId,
    discount,
    selectedPromotionDetails,
    discountType,
    discountId,
    promotionId,
    isOrderLevelDiscount, // 👈 NEW
  },
});

export const applyGlobalDiscount = (discountType, discountValue, discountId, reason = '') => ({
  type: APPLY_GLOBAL_DISCOUNT,
  payload: {
    discountType,
    discountValue,
    discountId,
    reason,
    appliedAt: new Date().toISOString(),
  },
});

export const removeGlobalDiscount = () => ({
  type: REMOVE_GLOBAL_DISCOUNT,
});

// Tax Operations
export const applyTax = (taxId, taxName, taxPercentage, taxAmount, taxType = 'additional') => ({
  type: APPLY_TAX,
  payload: {
    taxId,
    taxName,
    taxPercentage,
    taxAmount,
    taxType,
    appliedAt: new Date().toISOString(),
  },
});

export const removeTax = (taxId) => ({
  type: REMOVE_TAX,
  payload: { taxId },
});

// Order Type Management
export const setOrderType = (orderType) => ({
  type: SET_ORDER_TYPE,
  payload: orderType,
});

// Customer Management
export const setCustomer = (customer) => ({
  type: SET_CUSTOMER,
  payload: customer,
});

export const clearCustomer = () => ({
  type: CLEAR_CUSTOMER,
});

// Payment Method
export const setPaymentMethod = (paymentMethodId, paymentMethodName) => ({
  type: SET_PAYMENT_METHOD,
  payload: { paymentMethodId, paymentMethodName },
});

// Promotion Operations
export const applyPromotion = (promotionId, promotionCode, promotionDetails, discountAmount) => ({
  type: APPLY_PROMOTION,
  payload: {
    promotionId,
    promotionCode,
    promotionDetails,
    discountAmount,
    appliedAt: new Date().toISOString(),
  },
});

export const removePromotion = (promotionId) => ({
  type: REMOVE_PROMOTION,
  payload: { promotionId },
});

// Bulk Operations
export const updateMultipleItems = (updates) => ({
  type: 'UPDATE_MULTIPLE_CART_ITEMS',
  payload: updates,
});

export const applyBulkDiscount = (itemIndices, discount, discountType) => ({
  type: 'APPLY_BULK_DISCOUNT',
  payload: { itemIndices, discount, discountType },
});

// Cart Validation
export const validateCart = () => ({
  type: 'VALIDATE_CART',
});

// Cart Summary Actions
export const calculateCartSummary = () => ({
  type: 'CALCULATE_CART_SUMMARY',
});

// Hold Order
export const holdOrder = (orderData) => ({
  type: 'HOLD_ORDER',
  payload: orderData,
});

export const loadHeldOrder = (orderId) => ({
  type: 'LOAD_HELD_ORDER',
  payload: { orderId },
});

// Split Bill
export const splitBill = (splitCount, splitAmounts) => ({
  type: 'SPLIT_BILL',
  payload: { splitCount, splitAmounts },
});

// Print Operations
export const setPrintData = (receiptData) => ({
  type: 'SET_PRINT_DATA',
  payload: receiptData,
});

// Loyalty/Rewards
export const applyRewardPoints = (points, customerId) => ({
  type: 'APPLY_REWARD_POINTS',
  payload: { points, customerId },
});

export const removeRewardPoints = () => ({
  type: 'REMOVE_REWARD_POINTS',
});

// Notes/Instructions
export const addOrderNote = (note) => ({
  type: 'ADD_ORDER_NOTE',
  payload: { note, addedAt: new Date().toISOString() },
});

export const removeOrderNote = (noteId) => ({
  type: 'REMOVE_ORDER_NOTE',
  payload: { noteId },
});
